import * as React from 'react';
import { injectInitialProps } from '../../../utilities/components/Props';
import { Downloader } from '../../downloader/Downloader';
import {
    ItemDownloadAction as BaseItemDownloadAction,
    DownloadAction as BaseDownloadAction,
    IItemDownloadActionProps as IBaseItemDownloadActionProps,
    IDownloadActionProps as IBaseDownloadActionProps
} from '../../base/actions/download/DownloadAction';
import { IDecoratedProps } from '../../../utilities/components/Decorators';

export type IItemDownloadActionProps = IDecoratedProps<IBaseItemDownloadActionProps, Pick<IBaseItemDownloadActionProps, 'downloader'>, {}>;

export const ItemDownloadAction: React.ComponentType<IItemDownloadActionProps> =
    injectInitialProps((): Pick<IBaseItemDownloadActionProps, 'downloader'> => {
        return {
            downloader: Downloader
        };
    })(BaseItemDownloadAction);

export type IDownloadActionProps = IDecoratedProps<IBaseDownloadActionProps, Pick<IBaseDownloadActionProps, 'downloader'>, {}>;

export const DownloadAction: React.ComponentType<IDownloadActionProps> =
    injectInitialProps((): Pick<IBaseDownloadActionProps, 'downloader'> => {
        return {
            downloader: Downloader
        };
    })(BaseDownloadAction);
